document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-qty]').forEach(wrapper => {
    const input = wrapper.querySelector('input[type="number"]');
    if (!input) return;
    wrapper.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.delta || 0);
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
function initPinkHexHeroSlider(slider) {
  if (!slider || slider.dataset.sliderReady === 'true') return;
  slider.dataset.sliderReady = 'true';

  const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
  const prev = slider.querySelector('[data-hero-prev]');
  const next = slider.querySelector('[data-hero-next]');
  const autoplay = slider.dataset.autoplay === 'true';
  const speed = Math.max(3000, Number(slider.dataset.speed || 5000));
  let current = 0;
  let timer = null;

  if (slides.length < 2) return;

  const showSlide = (index, userInitiated = false) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((dot, i) => {
      const active = i === current;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (userInitiated) restart();
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    if (autoplay && !document.documentElement.classList.contains('shopify-design-mode')) {
      timer = window.setInterval(() => showSlide(current + 1), speed);
    }
  };

  const restart = () => {
    stop();
    start();
  };

  prev?.addEventListener('click', () => showSlide(current - 1, true));
  next?.addEventListener('click', () => showSlide(current + 1, true));
  dots.forEach(dot => dot.addEventListener('click', () => showSlide(Number(dot.dataset.heroDot), true)));
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin', stop);
  slider.addEventListener('focusout', start);
  start();

  document.addEventListener('shopify:block:select', event => {
    const selected = event.target.closest?.('[data-hero-slide]');
    if (!selected || !slider.contains(selected)) return;
    const index = slides.indexOf(selected);
    if (index >= 0) showSlide(index);
    stop();
  });
}

document.querySelectorAll('[data-hero-slider]').forEach(initPinkHexHeroSlider);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll?.('[data-hero-slider]').forEach(initPinkHexHeroSlider);
});
